import React, { useState, useEffect } from 'react'
import * as yup from "yup";
import jwt_decode from "jwt-decode";
import { saveToken, isLogin, adduser } from '../../actions'
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { allService } from '../../services';
import { useTranslation } from "react-i18next";
import toast, { Toaster } from 'react-hot-toast';
import { data } from 'jquery';

export default function Login() {

  // Declaration of project constant
  const history = useHistory();
  const dispatch = useDispatch();
  const [lang, setLang] = useState("Fr")
  const { t, i18n } = useTranslation();
  const [isDisable, setDisable] = useState(true);
  const [isDisableActivateAccount, setDisableActivateAccount] = useState(true);
  const [load, setLoad] = useState(false);
  const [activateAccountLoader, setActivateAccountLoader] = useState(false);
  const [error, setError] = useState({ phoneErr: '', passwordErr: '', serverErr: '', resendCodeErr: ''});
  const [userToLogin, setUserToLogin] = useState({ phone: '', password: ''});
  const [activateAccountForm, displayActivateAccountForm] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  // form validation rules 
  const schema = yup.object().shape({
    email: yup.string().email().required(),
    inputPassword: yup.string()
      .required('No password provided.')
      .min(6, 'Password is too short - should be 6 chars minimum.')
      .matches(/[a-zA-Z]/, 'Password can only contain Latin letters.')
  });

  const sendData = (e) => {
    e.preventDefault();
    const dataToStore = {
      telephone: userToLogin.phone,
      password: userToLogin.password,
    }
    loginUser(dataToStore);
  }

  // function that collects the data  on Submit
  async function loginUser(data) {
    setLoad(true);
    setError({... error,  serverErr: "", class: "err" });
    return allService.registerOrLogin(data, 'auth/login')
    .then((d) => {
      setLoad(true);
      dispatch(isLogin())
      dispatch(saveToken(d.authorisation.token))
      dispatch(adduser(d.user))
      setError({... error, serverErr: t("Authentification_successful"), class: "success" });
      if(d.user.role === "CLIENT"){
        history.push("/");
      }else{
        history.push("/dashboard");
      }
    })
    .catch((e) => {
      setLoad(false);
      if (e==="Login Failed"){
        setError({... error, serverErr: t("Incorrect_login"), class: "err"})
      }
      else if(e==="Account not active"){
        //setError({... error, serverErr: t("Account_not_active"), class: "err"})
        displayActivateAccountForm(true)
      }
      else if(e==="Account not verified"){
        setError({... error, serverErr: t("Account_not_verified"), class: "err" })
      }
      else{
        setError({... error, serverErr: t("Failed_to_connect_to_server"), class: "err"})
      }
    });
  };

  // function that navigate to forgot password
  const navToForgotPass = () => {
    history.push({
      pathname: '/forgot-password'
    });
  }
  // function that navigate to create account
  const navToregister = () => {
    history.push({
      pathname: '/register'
    });
  }

  //Function to use to handle language choice
  const changeLanguageHandler = (l) => {
    i18n.changeLanguage(l.toLowerCase());
    setLang(l)
  }

  const handleFormChange = (e) => {
    setUserToLogin({ ...userToLogin, [e.target.name]: e.target.value });
    if (e.target.name === "phone" && e.target.value){
      setError({ ...error, phoneErr: !allService.validateOrangePhone(e.target.value) && !allService.validateMtnPhone(e.target.value) && !allService.validateCamtelBlue(e.target.value) && !allService.validateCamtelPhone(e.target.value) && !allService.validateNextelPhone(e.target.value)? t("Enter_a_valid_num") : ''});
    }else if(e.target.name === "phone" && !e.target.value){
      setError({ ...error, phoneErr : ""});
    }

    if(e.target.name === "password" && e.target.value){
      setError({ ...error, passwordErr : e.target.value.length < 4 ? t("Requires_atleast_04_Characters") : ""})
    }else if(e.target.name === "password" && !e.target.value){
      setError({ ...error, passwordErr : ""});
    }

    if(e.target.name === "code" && e.target.value){
      setError({ ...error, codeErr : e.target.value.length < 5 ? t("code must be 5 digits") : ""})
    }
  }

  const verifyFormState = () => {
    let answer = true, answerActiveAccount = true;
    if (!allService.empty(userToLogin.phone) && !allService.empty(userToLogin.password)) {
      if (error.phoneErr === '' && error.passwordErr === '') {
          answer = false
        }
    }

    if(error.codeErr === ''){
      answerActiveAccount = false;
    }
    setDisable(answer)
    setDisableActivateAccount (answerActiveAccount);
  }

  useEffect(() => {
    verifyFormState()
   
  }, [error, userToLogin]);
 

  const saveData1 = () => {
    const dataToStore = {
        telephone: userToLogin.phone,
        code: userToLogin.code,
  
    }
    createUser1(dataToStore);
    console.log(data)
  }
  
  async function createUser1(data) {
    setActivateAccountLoader(true);
    setError({ ...error, serverErr: '' });
    return allService.registerOrLogin(data, 'auth/registration/code/verify')
        .then((d) => {
          setActivateAccountLoader(false);
          dispatch(isLogin())
          dispatch(saveToken(d.authorisation.token))
          dispatch(adduser(d.user))
          navigation("/")
        })
        .catch((e) => {
          setActivateAccountLoader(false);
            setError({ ...error, serverErr: e === "The code entered is not valid" ? t("wrong_code") : t("A_server_error") });
        });
  }
  
  const saveData2 = () => {
    const dataToStore = {
        telephone: userToLogin.phone,
    }
    createUser2(dataToStore);
  }
  
  async function createUser2(data) {
    setModalLoader(true);
    setError({ ...error, serverErr: '' });
    return allService.registerOrLogin(data, 'auth/registration/code/resend')
        .then((d) => {
          setModalLoader(false);
          toast.success(t("resent_code"), {
            style: {
              padding: '16px',
              color: '#fff',
              background: '#02274a',
              borderRadius: '10px',
            },
            iconTheme: {
              primary: '#229954',
              secondary: '#FFFAEE',
            },
          });
        })
        .catch((e) => {
          setModalLoader(false);
          setError({ ...error, serverErr: t("Failed_to_connect_to_server") });
        });
  }
  
  function back() {
    displayActivateAccountForm(false)
  }

  // function use to naviagte a user
  const navigation = (nav) => {
    history.push({
        pathname: nav,
    });
  };
  return (
    <div className="row no-gutters h-100 w-100" style={{ position: 'absolute' }}>
      <div className="col col-6 d-none d-md-block p-0 h-100 text-center" style={{
        background: '#000a2b', color: '#fff'
      }}>
        <div className="mb-5" style={{ height: '45px' }}>
          <div style={{
            display: 'inline-block', verticalAlign: 'bottom', fontSize: '0.795em', float: 'left',
            position: 'relative', left: '30px', top: '20px'
          }}>
            <div style={{ marginRight: '5px', display: 'inline-block', verticalAlign: 'middle' }}><span
              className="lang" keyword="fr">{lang}</span></div><button
                className="btn btn-primary option rounded-circle" type="button" style={{
                  display: 'inline-block'
                  , padding: '1px 5px', paddingTop: '6px', fontSize: '0.985em', boxShadow: 'none',
                  position: 'relative'
                }} data-toggle="dropdown"><i
                  className="material-icons">{t("Language")}</i></button>
            <div className="dropdown-menu drop-lang mt-1" role="menu" style={{ fontSize: '1.26em' }}><a onClick={() => changeLanguageHandler("Fr")}  id="fr"
              className="translate" data-reload><img src="assets/img/france_96px.png"
                style={{ width: '20px', position: 'relative', top: '-3px' }} />&nbsp; <span
                  className="lang" keyword="french" style={{
                    position: 'relative', top: '-2px'
                  }}>{t("french-lang")}</span><br /></a><a onClick={() => changeLanguageHandler("En")}  id="en" className="translate"><img
                    src="assets/img/great_britain_96px.png" style={{
                      width: '20px', position: 'relative',
                      top: '-3px'
                    }} />&nbsp; <span className="lang" keyword="english"
                      style={{ position: 'relative', top: '-2px' }}>{t("english-lang")}</span></a></div>
          </div>
        </div>
        <div className="d-inline-block text-center" style={{ marginTop: '25%' }}><img
          className="img-fluid m-auto d-block" src="assets/img/Logo-Glotelho-Pay-2.png" style={{
            width: '45%'
          }} /></div>
        <div className="w-100" style={{
          color: '#B2BABB', fontSize: '0.865em', position: 'absolute', bottom: '10%'
        }}>
          <p className="w-75 m-auto">{t("one_click")}<br /></p>
        </div>
      </div>
      <div className="col col-12 col-md-6 p-0 h-100 of-a" style={{ background: '#fff' }}>
        <div className="w-100 d-block d-md-none" style={{ height: 'auto', position: 'fixed', zIndex: 2000 }}>
          <div className="text-center elipsis pl-2 pr-2 d-block d-md-none" style={{ background: '#C69E44', color: '#fff' }}><span className="ads-txt"><span><strong>No
            1</strong></span><span className="font-weight-light">&nbsp;{t("Number_refill")}</span></span>
          </div>
          <div style={{ height: '70px', background: '#000a2b', color: '#fff', padding: '0 15px' }}>
            <div className="fl-l logo" style={{ position: 'relative' }}><img className="img-fluid" src="assets/img/glo-pay.png" /></div>
            <div className="fl-r mr-2" style={{ display: 'inline-block', verticalAlign: 'bottom', fontSize: '0.795em', position: 'relative', top: '16px' }}>
              <div style={{ marginRight: '5px', display: 'inline-block', verticalAlign: 'middle' }}>
                <span className="lang" keyword="fr">{lang}</span>
              </div>
              <button className="btn btn-primary option rounded-circle" type="button" style={{ display: 'inline-block', padding: '1px 5px', paddingTop: '5px', fontSize: '0.985em', boxShadow: 'none', position: 'relative' }} data-toggle="dropdown" title="Langue">
                <i className="material-icons">language</i>
              </button>
              <div className="dropdown-menu drop-lang" role="menu"  style={{ marginRight: '16px', marginTop: '5px', fontSize: '1.26em' }}>
                <a onClick={() => changeLanguageHandler("Fr")}  id="fr" className="translate" data-reload>
                  <img src="assets/img/france_96px.png" style={{ width: '20px', position: 'relative', top: '-3px' }} />&nbsp;
                  <span className="lang" keyword="french" style={{ position: 'relative', top: '-2px' }}>{t("french-lang")}</span><br />
                </a>
                <a onClick={() => changeLanguageHandler("En")} id="en" className="translate"><img src="assets/img/great_britain_96px-1.png"  style={{ width: '20px', position: 'relative', top: '-3px' }} />&nbsp;
                  <span className="lang" keyword="english" style={{ position: 'relative', top: '-2px' }}>{t("english-lang")}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className='space3'></div>
        <div className="col-12 col-sm-9
         col-md-10 col-lg-9 col-xl-8 mt-form" style={{padding: '25px 30px',background: '#fff'}}>
         {activateAccountForm===false && <form id="login" onSubmit={(e) => sendData(e)} className="display" style={{ display: 'block' }}>
            <h1 className="mb-2 fw-900 title0" style={{ lineHeight: 1 }}>{t("login")} </h1><span
              className="fw-300">{t("No_account")} <span className="fw-600 cursor" onClick={()=>navToregister()}>{t("Create_one")}</span>.</span>
            <div className="mt-4 mb-4">
              <h6 className="text-left fw-300" style={{ fontSize: '0.9rem' }}>{t("Telephone_number")}</h6>
              <input name="phone" value={userToLogin.phone} onChange={(e)=> handleFormChange(e)} className="form-control" type="number" style={{width: '100%', borderRadius: 0, height: '55px', fontWeight: 600}} />
              {error.phoneErr && <span id="login-msg" className="err">{error.phoneErr}</span>}
            </div>
            <div className="mb-4">
              <h6 className="text-left fw-300" style={{ fontSize: '0.9rem' }}>{t("password")}</h6>
              <input  name="password" value={userToLogin.password} onChange={(e)=> handleFormChange(e)} className="form-control mb-2" type="password" style={{width: '100%', borderRadius: 0,height: '55px', fontWeight: 600}}/>
                {error.passwordErr && <span className="text-left err d-block">{error.passwordErr}</span>}
                <span className="cursor d-block text-right" onClick={() => navToForgotPass()}>{t("forget-password")}</span>
            </div>
            <button disabled={load || isDisable} className="btn btn-primary mt-2 mb-3 app-btn" type="submit" style={{width: '100%',textTransform: 'uppercase', boxShadow: 'none', borderRadius: 'initial', padding: '15px'}}>
              {!load && <i className="icon-lock-open" style={{ top: "1px" }} />}{load && <i className="fa fa-circle-o-notch fa-spin speed-spin" style={{ top: "0px" }}></i>}&nbsp; <span>{t("login")}<br /></span>
            </button>
            {!allService.empty(error.serverErr) && <span className="err d-block mb-2"><i className="icon-exclamation mr-2" />{error.serverErr}.</span>}
            <span className="fw-300 d-block"><span onClick={() => navigation("/")} className="cursor app-color fw-600">{t("recharger")}</span>&nbsp;{t("without_account")}.</span>
          </form>}
          <div className="col col-12 col-lg-8 text-center mt-5" style={{margin: "auto"}}><span className="d-block mb-2 fw-300">{t("now_available_app")} : </span>
            <div className="row">
                <div className="col p-0 pr-1"><a href="https://play.google.com/store/apps/details?id=cm.glotelho.glotelho_pay" target="_blank"><img className="img-fluid" src="assets/img/google.png" /></a></div>
                <div className="col p-0 pl-1"><a href="https://apps.apple.com/be/app/glotelho-pay/id1660530553" target="_blank"><img className="img-fluid" src="assets/img/apple.png" /></a></div>
            </div>
          </div>
          {activateAccountForm===true && <form id="activate-account" >
            <div>
              <div className="d-inline-block" style={{ verticalAlign: 'top' }}>
                <h1 onClick={()=>back()} className="mb-0" style={{ fontWeight: 900 }}><i
                  className="icon ion-arrow-left-c mr-2 cursor" />
                </h1>
              </div>
              <div className="d-inline-block" style={{ verticalAlign: 'top', width: '83%' }}>
                <h1 className="mb-2 title" style={{ fontWeight: 900, lineHeight: 1 }}>{t("Activate_account")}</h1>
              </div>
              <div className="display" style={{display: "block"}}>
                <span style={{ fontWeight: 200 }}>{t("We_have_sent_confirm")}</span>
                <div className="mt-4 mb-4">
                  <h6 className="fw-300" style={{ fontSize: '0.9rem' }}>{t("Activation_code")}</h6>
                  <input className="form-control" type="number" name = "code" onChange={(e)=> handleFormChange(e)} />
                  {!allService.empty(error.serverErr) && <span className="err d-block mt-2"><i className="icon-exclamation mr-2" />{error.serverErr}.</span>}
                </div>
                <button disabled= {activateAccountLoader || isDisableActivateAccount} onClick={()=> saveData1() } className="btn btn-primary mb-3 app-btn" type="button" style={{width: '100%',textTransform: 'uppercase', boxShadow: 'none', borderRadius: 'initial',padding: '15px'}}>
                  {!activateAccountLoader && <i className="icon-lock-open" />} {activateAccountLoader && <i className="fa fa-circle-o-notch fa-spin speed-spin pr" style={{ top: "-1px" }}></i>}&nbsp; {t("Activate_account")}
                </button>
                <span className="mb-5 fw-300">{t("I_didnt_receive")}, &nbsp;<span className="cursor app-color fw-600"  onClick={()=> saveData2()} >{t("resend_code")}</span></span>
              </div>
            </div>
          </form>}
          <span className="fw-100 second-txt-color d-block mt-5 text-center" style={{
            fontSize: '0.865em'
          }}><i className="fa fa-copyright fw-100" />&nbsp;<span>2022</span>&nbsp;<strong>Glotelho
            Pay&nbsp;</strong><span className="lang fw-100 second-txt-color"
              keyword="all-rights-reserved">{t("All_rights_reserved")}</span>.</span>
        </div>
      </div>

      {modalLoader && <div className="modal modal-load text-center display" style={{display:`${modalLoader ? "block" : "none"}`,paddingTop:"120px",backgroundColor:"rgba(255,255,255,0.6)",color:"#091e42"}}>
        <div className="w-100" style={{marginTop:"8em"}}>
          <img src="assets/img/Eclipse-0.3s-800px.gif" alt="loader" className="mb-3" style={{width:"140px"}} />
          <p className="fw-600" style={{fontSize:"0.9em"}}>{t("processing")} ...</p>
        </div>
      </div>}

      <Toaster toastOptions={{ position: "bottom-center" }} />
    </div>
  )
}
